import { Skeleton } from "@repo/ui/components/ui/skeleton";
import { useUserForm } from "../hooks/use-user-form";
import { UserFormFields } from "./user-form-fields";

interface EditUserFormProps {
  userId: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EditUserForm({ userId, onCancel, onSuccess }: EditUserFormProps) {
  const {
    form,
    isEditMode,
    isSubmitting,
    isLoading,
    error,
    fieldErrors,
    onSubmit,
  } = useUserForm({ userId, onSuccess });

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <div className="flex gap-2">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      </div>
    );
  }

  return (
    <UserFormFields
      form={form}
      isEditMode={isEditMode}
      isSubmitting={isSubmitting}
      error={error}
      fieldErrors={fieldErrors}
      onSubmit={onSubmit as any}
      onCancel={onCancel}
    />
  );
}
